import React from 'react'
import { Box, Text } from '@chakra-ui/react'
import {
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerFooter,
} from '@chakra-ui/react'

import { AppointmentFieldsFragment } from '~graphql/generated/graphql'
import AppointmentDetails from '~components/appointments/detailed-appointment/details'
import { useBreakpointValue } from '@chakra-ui/react'
import { Button, IconButton } from '@chakra-ui/react'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import OutlineBox from '~components/shared/wrappers/outline-box'

interface Props {
    appointment: AppointmentFieldsFragment
    onConfirm: () => Promise<void>
    isLoading: boolean
    isOpen: boolean
    onClose: () => void
}

export default function ManualEntryReviewDrawer({
    isOpen,
    onClose,
    appointment,
    isLoading,
    onConfirm,
}: Props) {
    const modalSize = useBreakpointValue({ base: 'full', md: 'lg' })

    async function handleConfirm() {
        await onConfirm()
        onClose()
    }

    return (
        <Drawer isOpen={isOpen} onClose={onClose} size={modalSize}>
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader
                    pb={4}
                    shadow="blue.md"
                    display="flex"
                    justifyContent="space-between"
                >
                    <IconButton
                        size="sm"
                        icon={<ChevronLeftIcon fontSize="xl" />}
                        variant="outline"
                        rounded="full"
                        aria-label="Close Modal"
                        onClick={onClose}
                    />
                </DrawerHeader>
                <DrawerBody px={{ base: 2, md: 6 }} py={{ base: 4, md: 6 }}>
                    <OutlineBox
                        shadow="none"
                        bg="gray.100"
                        mx={-2}
                        mb={4}
                        rounded="lg"
                    >
                        <Text fontWeight="medium" fontSize="sm">
                            Review and enter the appointment details in your
                            practice management software and then confirm the
                            manual entry
                        </Text>
                    </OutlineBox>
                    <AppointmentDetails appointment={appointment} />
                </DrawerBody>
                <DrawerFooter
                    gap={4}
                    justifyContent="flex-start"
                    shadow="blue.top"
                >
                    <Button
                        colorScheme="brand"
                        size="sm"
                        onClick={handleConfirm}
                        isLoading={isLoading}
                    >
                        Confirm & Mark as Resolved
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    )
}
